import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { ComboBox } from '@syncfusion/ej2-dropdowns';

import { routes } from '@/shared/routes';
import { appendQuery } from '@/shared/utils/url';

document.addEventListener('DOMContentLoaded', () => {
  [...document.querySelectorAll('.template-picker')]
    .map((element) => element as HTMLSpanElement)
    .forEach((element) => {
      const { templateId, taskId } = element.dataset;

      const input = element.querySelector('input');

      const form = input?.form;

      if (input && form) {
        const templatePicker = new ComboBox({
          dataSource: new DataManager({
            url: appendQuery(routes.emailTemplates.search(), { taskId }),
            adaptor: new UrlAdaptor(),
          }),
          fields: {
            value: 'id',
            text: 'name',
            groupBy: 'serviceName',
          },
          placeholder: 'Search templates',
          groupTemplate: '${if(serviceName)}${serviceName}${else}Other${/if}',
          value: templateId,
          allowCustom: false,
          allowFiltering: true,
          change: () => form.submit(),
        });

        templatePicker.appendTo(input);
      }
    });
});
